import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  CategoryListNavComponent,
  Dropdown,
  Item,
  NavData,
  NavSettings,
} from '@digital-platform/ui-base-components/category-list-nav';

@Component({
  selector: 'digital-platform-report-tracker',
  standalone: true,
  imports: [CommonModule, CategoryListNavComponent],
  templateUrl: './report-tracker.component.html',
  styleUrls: ['./report-tracker.component.scss'],
})
export class ReportTrackerComponent {
  @Input() data: NavData = [] as NavData;
  @Input() settings: NavSettings = {} as NavSettings;

  private _favorites: Item[] = [];
  @Input()
  get favorites(): Item[] {
    return this._favorites;
  }

  set favorites(value: Item[]) {
    this._favorites = value;
  }

  @Output() itemClick = new EventEmitter<Item>();
  @Output() itemInfoClick = new EventEmitter<Item>();
  @Output() dropdownClick = new EventEmitter<Dropdown>();
  @Output() favoriteItemRemoved = new EventEmitter<Item>();
  @Output() favoritesChanged = new EventEmitter<Item>();

  handleItemClick(item: Item) {
    this.itemClick.emit(item);
    console.log('Item clicked:', item);
  }
  handleItemInfoClick(item: Item) {
    this.itemInfoClick.emit(item);
    console.log('Item info clicked:', item);
  }
  handleDropdownClick(dropdown: Dropdown) {
    this.dropdownClick.emit(dropdown);
    console.log('Dropdown clicked:', dropdown);
  }
  handleFavoriteItemRemoved(item: Item) {
    this.favoriteItemRemoved.emit(item);
    console.log('Favorite item removed:', item);
  }
  handleFavoritesChanged(item: Item) {
    this.favoritesChanged.emit(item);
    console.log('Favorites changed:', item);
  }
  addFavoriteItem(item: Item) {
    console.log('Item added to favorites:', item);
    this.favorites.push(item);
  }
}
